module.exports = __webpack_public_path__ + "media/images/raiselogo-84b30d06.png";